import { Command } from 'prosemirror-state';

import { EditorView } from '@lyearn/lygo-core';

import { linkMarkMenuKey } from './index';

export const openLinkMarkMenu = (editorView: EditorView) => {
  const { state } = editorView;
  const { selection } = state;
  const { empty } = selection;
  if (!empty) {
    editorView.dispatch(
      editorView.state.tr.setMeta(linkMarkMenuKey, {
        open: true,
      }),
    );
  }
};

export const hideLinkMarkMenu: Command = (state, dispatch) => {
  if (dispatch) {
    dispatch(state.tr.setMeta(linkMarkMenuKey, { open: false }));

    return true;
  }

  return false;
};
